import BaseWs from './base.ws'

class WebStreamWs extends BaseWs {
  get NOTIFICATION_COUNT_STREAM() {
    return 'web_site.notification_count'
  }

  get ENTITY_LOCK_STREAM() {
    return 'web_site.entity_lock'
  }

  get IMPORT_PROGRESS_STREAM() {
    return 'registry.import_progress'
  }

  get KANBAN_UPDATE_STREAM() {
    return 'garage.kanban_update'
  }

  constructor() {
    super('web-stream')
  }
}

export const useWebStreamWs = () => {
  return new WebStreamWs()
}
